import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetStudentApplicationsResponse } from '@edtech-ui/core/models/student-job-management/get-all-my-applications';
import { GetStudentJobDetailResponse } from '@edtech-ui/core/models/student-job-management/get-all-student-job-details';
import { GetAllStudentJobsResponse } from '@edtech-ui/core/models/student-job-management/get-all-student-jobs';
import { StudentRemoveJobResponse, StudentSaveJobResponse } from '@edtech-ui/core/models/student-job-management/post-student-save-jobs';
import { StudentGetJobApplicationSubmittedResponse } from '@edtech-ui/core/models/student-job-management/student-application-submitted';
import { StudentApplyJobApplicationResponse } from '@edtech-ui/core/models/student-job-management/student-appy-job';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StudentJobService {

	apiUrl = environment.StudentJobApiUrl;

	constructor(
		private http: HttpClient
	) { }


	getAllStudentsJobs(
		page: number = 1,
		limit: number = 10,
		tab: string = 'recommended',
		status?: string,
		search?: string,
		filter?: any
	): Observable<GetAllStudentJobsResponse> {
		let params = new HttpParams()
			.set('tab', tab)
			.set('page', page.toString())
			.set('limit', limit.toString());

		if (status) {
			params = params.set('status', status);
		}

		if (search) {
			params = params.set('search', search);
		}

		if (filter?.job_type) {
			params = params.set('job_type', filter.job_type);
		}

		if (filter?.work_mode) {
			params = params.set('work_mode', filter.work_mode);
		}

		if (filter?.location) {
			params = params.set('location', filter.location);
		}

		if (filter?.is_visible !== undefined && filter?.is_visible !== null) {
			params = params.set('is_visible', String(filter.is_visible));
		}

		if (filter?.preferred_job_role_category) {
			params = params.set('preferred_job_role_category', filter.preferred_job_role_category);
		}

		if (filter?.preferred_job_title) {
			params = params.set('preferred_job_title', filter.preferred_job_title);
		}

		if (filter?.skills && Array.isArray(filter.skills)) {
			filter.skills.forEach((skill: string) => {
				params = params.append('skills', skill);
			});
		}

		return this.http.get<GetAllStudentJobsResponse>(`${this.apiUrl}/feed`, { params });
	}


	getAllStudentJobDetails(jobId: string): Observable<GetStudentJobDetailResponse> {
		return this.http.get<GetStudentJobDetailResponse>(`${this.apiUrl}/${jobId}`);
	}


	postStudentSaveJob(jobId: string): Observable<StudentSaveJobResponse> {
		return this.http.post<StudentSaveJobResponse>(`${this.apiUrl}/${jobId}/save`, jobId)
	}

	deleteStudentSaveJob(jobId: string): Observable<StudentRemoveJobResponse> {
		return this.http.delete<StudentRemoveJobResponse>(`${this.apiUrl}/${jobId}/save`, { body: { job_id: jobId } });
	}


	getAllStudentSaveJobs(page: number, limit: number): Observable<GetAllStudentJobsResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit);
		return this.http.get<GetAllStudentJobsResponse>(`${this.apiUrl}/saved`, { params });
	}


	getAllStudentApplications(page: number, limit: number): Observable<GetStudentApplicationsResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit);
		return this.http.get<GetStudentApplicationsResponse>(`${this.apiUrl}/applications`, { params })
	}


	postStudentApplyJobApplication(payload: FormData, jobId: string): Observable<StudentApplyJobApplicationResponse> {
		return this.http.post<StudentApplyJobApplicationResponse>(`${this.apiUrl}/${jobId}/apply`, payload);
	}


	getStudentJobApplicationSubmitted(jobId: string): Observable<StudentGetJobApplicationSubmittedResponse> {
		return this.http.get<StudentGetJobApplicationSubmittedResponse>(`${this.apiUrl}/${jobId}/application-submitted`);
	}


}
